const messages = {
  dashboard: {
    title: "{name} Cruscotto",
    extraTitle: "WHOLESALER DASHBOARD",
    description:
      "Benvenuti nel vostro cruscotto. Qui potete visualizzare le cifre chiave attuali e le aziende partecipanti della vostra base clienti.",
    overview: {
      title: "Panoramica dei clienti partecipanti",
      description:
        "Aziende che si sono registrate presso BRIDGESTONE PLUS e che possiamo assegnare alla vostra azienda tramite il codice cliente.",
      month: "Novità del mese",
      year: "Novità di quest'anno",
      all: "Totale",
    },
    credits: {
      title: "Punti crediti {name}",
      description:
        "Punti premio assegnati alle aziende partecipanti in base ai dati di vendita caricati. Questa visualizzazione mostra i punti regolari senza promozioni speciali.",
      month: "Il mese scorso",
      year: "Anno in corso",
      prev_year: "Totale",
      allDealers: "Tutti i punti di vendita",
    },
    details: {
      title: "I clienti partecipanti in dettaglio",
      description:
        'Di seguito sono elencate le aziende che si sono registrate con un numero cliente {name} su BRIDGESTONE <span class="text-danger">PLUS</span> e che sono assegnate a voi come persona responsabile. È sufficiente utilizzare le funzioni di ordinamento per una diversa sequenza di pneumatici o la maschera di ricerca.',
    },
    lastImport:
      'Ultima importazione di dati di vendita: <br/> <span class="text-danger">{date}</span>',
    loadMore: "Carica altri 20 rivenditori",
    tyres: {
      title: "Pneumatici",
      description: "Pneumatici acquistati dai partecipanti al programma",
    },
  },
};

export default {
  messages,
};
